module.exports = __webpack_public_path__ + "static/media/briefcase-account-outline.0c4194be.svg";